import { render, staticRenderFns } from "./indexForm.vue?vue&type=template&id=6b7f4e34&scoped=true&"
import script from "./indexForm.vue?vue&type=script&lang=ts&"
export * from "./indexForm.vue?vue&type=script&lang=ts&"
import style0 from "./indexForm.vue?vue&type=style&index=0&id=6b7f4e34&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f4e34",
  null
  
)

export default component.exports